angular.module('wbDirectives').directive 'wbActiveLink', ->
  scope: false
  restrict: 'A'
  link: ($scope, $el, $attrs) ->
    firstRoute = '/' + window.location.pathname.split('/')[1]
    if firstRoute == $attrs.href
      angular.element($el).addClass('active')
